export const sqlDarkTheme: monaco.editor.IStandaloneThemeData = {
  base: 'vs-dark',
  inherit: true,
  rules: [
    {
      token: 'comment',
      foreground: '838690',
    },
    {
      token: 'string.sql',
      foreground: 'FFB58C',
    },
    {
      token: 'identifier',
      foreground: 'E9E7EB',
    },
    {
      token: 'keyword',
      foreground: '8ECEF5',
    },
    {
      token: 'operator.sql',
      foreground: '82D7AB',
    },
    {
      token: 'predefined.sql',
      foreground: 'E671C6',
    },
  ],
  colors: {
    'editor.foreground': '#000000',
    'editor.background': '#1E2025',
    'editor.selectionHighlight': '#82D7AB',

    'input.border': '#6E26EC',
    contrastBorder: '#373943',

    'editorWidget.background': '#26282E',
    'editorWidget.border': '#373943',

    'editorSuggestWidget.background': '#26282E',
    'editorSuggestWidget.selectedBackground': '#401E8A',
    'editorSuggestWidget.highlightForeground': '#948AFD',
    'editorSuggestWidget.border': '#373943',
    'editorSuggestWidget.foreground': '#E9E7EB',

    'list.highlightForeground': '#948AFD',
    'list.activeSelectionBackground': '#401E8A',
    'list.hoverBackground': '#373943',
  },
};
